<template>
  <div>
    <div class="infoBanner">
      <div class="panel-default">
        <div class="count-detail-wrapper">
          <div class="count-details">
            <VIcon :size="-2" connotation="cta" name="group-line" class="txt_clr_primary desktop-only"></VIcon>
            <div class="description">
              <h2 class="count-number">{{ isViewOnlyMode || isURLUpload ? (targeting_count ?? '-') : targetedCustomerCount }}</h2>
              <p class="sub-title">Target Customers</p>
            </div>
          </div>
          <div v-if="!isURLUpload" class="refresh-button">
            <VButton
              :disabled="loadingCount || isViewOnlyMode"
              class="vvd-btn-secondary"
              connotation="cta"
              appearance="outlined"
              :label="!loadingCount ? 'Get the count' : ''"
              @click="initFetchCount"
            >
              <template v-if="loadingCount" #icon>
                <VProgressRing class="vvd-spinner vvd-spinner-sm" connotation="cta" indeterminate />
              </template>
            </VButton>
          </div>
        </div>
        <div class="panel-info">
          <VIcon name="info-line" :size="-5" connotation="cta" class="txt_clr_primary"></VIcon>
          <span class="info-text">Approximate count of target customers according to the conditions you have set.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiInterceptor from '@/shared/apiInterceptor';
import { parseTargetingConditions } from '@/helpers/segments.helpers';
import { useAuthStore } from '@/stores/auth';
import { useUIStore } from '@/stores/ui';
import { environment } from '@/shared/env.js';

export default {
  emits: ["callFetchTargetedCustomerCount"],
  data() {
    return {
      loading: 0,
      loadingCount: false,
      targetedCustomerCount: '-',
    };
  },
  props: {
    targetingConditionJson: {
      type: Object
    },
    sendTag: {
      type: String
    },
    isViewOnlyMode: {
      type: Boolean,
      default: false
    },
    targeting_count: {
      type: Number
    },
    isURLUpload: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    initFetchCount() {
      this.$emit('callFetchTargetedCustomerCount');
    },
    async fetchTargetedCustomerCount(targetingConditionJson, from) {
      let errorMessage = '';
      this.loadingCount = true;
      try {
        let reqBody = {};
        let targetingConditions = targetingConditionJson;
        if (typeof targetingConditions === 'string') {
          targetingConditions = parseTargetingConditions(targetingConditions, useAuthStore().authData?.userId);
        }
        reqBody['targeting_conditions'] = targetingConditions;
        if(this.sendTag) reqBody['sendtag'] = this.sendTag;
        const baseUrl = environment('VUE_APP_API_URL');
        const endpoint = `${baseUrl}crm/v1/customers/count`;
        const targetedCustomerCountResponse = await apiInterceptor.post(endpoint, reqBody);
        this.targetedCustomerCount = targetedCustomerCountResponse.total;
      } catch (error) {
        errorMessage = error.message;
      } finally {
        this.loadingCount = false;
        if (errorMessage) {
          useUIStore().updateToast({ open: true, message: errorMessage, type: "danger", });
        }
      }
    },
    async fetchTargetedCustomerCountByQueryString(queryString, from) {
      let errorMessage = '';
      this.loadingCount = true;
      try {
        let reqBody = {
        };
        const result = parseTargetingConditions(queryString, useAuthStore().authData?.userId);
        reqBody['targeting_conditions'] = result;
        if (this.sendTag) { reqBody['sendtag'] = this.sendTag; }
        const baseUrl = environment('VUE_APP_API_URL');
        const endpoint = `${baseUrl}crm/v1/customers/count`;
        const targetedCustomerCountResponse = await apiInterceptor.post(endpoint, reqBody);
        this.targetedCustomerCount = targetedCustomerCountResponse.total;
      } catch (error) {
        errorMessage = error.message;
      } finally {
        this.loadingCount = false;
        if (errorMessage) {
          useUIStore().updateToast({ open: true, message: errorMessage, type: "danger", });
        }
      }
    }
  },
};
</script>

<style scoped>
.infoBanner .panel-default {
  border-radius: 5px;
  border: 1px solid var(--background-primary);
  box-shadow: none;
  margin-bottom: 0px;
  padding: 15px;
  background: var(--white);
}
.description .count-number {
  font-weight: 400;
  font-size: 32px;
  line-height: 37px;
  color: var(--black);
  margin: 0;
}
.description .sub-title {
  font-size: 14px;
  font-weight: 400;
  color: var(--gray-04);
  margin: 0;
}
.panel-info {
  background: var(--purple-opac);
  border-radius: 5px;
  margin-top: 10px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}
.info-text {
  font-size: 14px;
  font-weight: 400;
  color: var(--black);
}
.count-detail-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.count-details {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

/* Responsive */
.desktop-only {
  display: inline-flex;
}
@media only screen and (max-width: 760px) {
  .desktop-only {
    display: none !important;
  }
}
</style>
